import { render, staticRenderFns } from "./SchoolOrderModal.vue?vue&type=template&id=4b248efe&scoped=true"
import script from "./SchoolOrderModal.vue?vue&type=script&lang=js"
export * from "./SchoolOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b248efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b248efe')) {
      api.createRecord('4b248efe', component.options)
    } else {
      api.reload('4b248efe', component.options)
    }
    module.hot.accept("./SchoolOrderModal.vue?vue&type=template&id=4b248efe&scoped=true", function () {
      api.rerender('4b248efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolOrder/modules/SchoolOrderModal.vue"
export default component.exports